<template>
<div>
  <Nav :navTitle="navTitle" :leftText="leftText" :rightText="rightText" :leftArrow="leftArrow" />
  <div class="content">
    <van-form @submit="submitJsyTwo">
      <van-cell-group inset>
        <div class="upload-box">
          <h2 class="upload-titile input-title-hq red-required">行驶证正页 <span class="image-show" @click="showImageDemo('zbfm')">（示例:如图）</span></h2>
          <div class="upload-xsz-box">
            <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="xsz_zb_fm_image" :before-read="beforeRead" :after-read="uploadXszZbFm" :before-delete="deleteXszZbFm"></van-uploader>
          </div>

          <h2 class="upload-titile input-title-hq red-required">行驶证副页 <span class="image-show" @click="showImageDemo('fbzm')">（示例:如图）</span></h2>
          <div class="upload-xsz-box">
            <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="xsz_fb_zm_image" :before-read="beforeRead" :after-read="uploadXszFbZm" :before-delete="deleteXszFbZm"></van-uploader>
          </div>

          <h2 class="upload-titile input-title-hq">行驶证副页反面 <span class="image-show" @click="showImageDemo('fbfm')">（示例:如图）</span></h2>
          <div class="upload-xsz-box">
            <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="xsz_fb_fm_image" :before-read="beforeRead" :after-read="uploadXszFbFm" :before-delete="deleteXszFbFm"></van-uploader>
          </div>

          <h2 class="upload-titile input-title-hq red-required">槽车整体照片（能看见车挂号、轴数）<span class="image-show" @click="showImageDemo('zbzm')">（示例:如图）</span></h2>
          <div class="upload-xsz-box">
            <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="xsz_zb_zm_image" :before-read="beforeRead" :after-read="uploadXszZbZm" :before-delete="deleteXszZbZm"></van-uploader>
          </div>

          <div class="jsz-front-info-box">
            <van-field v-model="cheguahao" name="cheguahao" input-align="right" required :value="cheguahao" :rules="[{ validator:validatorChegua, message: '请填写车挂号' }]" placeholder="请输入">
              <template #label>
                <span class="input-left-label-hq">车挂号</span>
              </template>
            </van-field>
            <van-field v-show="cheShow" v-model="chejiahao" input-align="right"  name="chejiahao" :value="chejiahao"  placeholder="请输入">
              <template #label>
                <span class="input-left-label-hq">车辆识别代号</span>
              </template>
            </van-field>

            <van-field v-model="sscd" name="sscd" input-align="right" required :value="sscd" :rules="[{ validator:validatorSscd, message: '请填写所属车队' }]" placeholder="请输入">
              <template #label>
                <span class="input-left-label-hq">所属车队</span>
              </template>
            </van-field>

            <van-field v-model="zhengbeizhiliang" name="zhengbeizhiliang" input-align="right" required :value="zhengbeizhiliang" type="number" :rules="[{ validator:validatorZbzl, message: '请填写整备质量' }]">
              <template #extra>
                <div class="unit">KG</div>
              </template>
              <template #label>
                <span class="input-left-label-hq">整备质量</span>
              </template>
            </van-field>

            <van-field v-model="zongzhiliang" name="zongzhiliang" input-align="right" required type="number" :value="zongzhiliang" :rules="[{ validator:validatorZongzhiliang, message: '请填写总质量' }]">
              <template #extra>
                <div class="unit">KG</div>
              </template>
              <template #label>
                <span class="input-left-label-hq">总质量</span>
              </template>
            </van-field>
            <van-field v-model="xingshizhenghdzzl" name="xingshizhenghdzzl" input-align="right" required type="number" :value="xingshizhenghdzzl" :rules="[{ validator:validatorXingshizhenghdzzl, message: '请填写行驶证核定载质量' }]">
              <template #extra>
                <div class="unit">吨</div>
              </template>
              <template #label>
                <span class="input-left-label-hq">行驶证核定载质量</span>
              </template>
            </van-field>
            <ChoseTime :timeVmodel="xszYxq" :timeName="xszYxq" :timeLabel="xszYxqLabel" @getYxq="getXszYxq" :timeValue="xingshizhengyxq" />
            <chose-zhou-shu @getZhouShu="getZhouShu" :zhoushuValue="zhoushu"></chose-zhou-shu>
          </div>
        </div>
      </van-cell-group>

      <div class="itemBox">
        <van-cell-group inset>
          <div class="upload-box">
            <h2 class="upload-titile input-title-hq red-required">道路运输证正本正面图片 <span class="image-show" @click="showImageDemo('dlyszm')">（示例:如图）</span></h2>
            <div class="upload-dlysz-box">
              <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="dlys_zm_image" :before-read="beforeRead" :after-read="uploadDlysZm" :before-delete="deleteDlysZm"></van-uploader>
            </div>
            <h2 class="upload-titile input-title-hq title-extend">道路运输证（待理证）正面图片<span>（车辆信息和经营范围2页拍在一起）</span> <span class="image-show" @click="showImageDemo('dlczm')">（示例:如图）</span></h2>
            <div class="upload-dlysz-box">
              <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="dcl_zm_image" :before-read="beforeRead" :after-read="uploadDclZm" :before-delete="deleteDclZm"></van-uploader>
            </div>
            <h2 class="upload-titile input-title-hq">道路运输证（待理证）反面图片 <span class="image-show" @click="showImageDemo('dlcfm')">（示例:如图）</span></h2>
            <div class="upload-dlysz-box">
              <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" max-count="1" v-model="dcl_fm_image" :before-read="beforeRead" :after-read="uploadDclFm" :before-delete="deleteDclFm"></van-uploader>
            </div>
            <van-field v-model="daoluyszhao" name="daoluyszhao" input-align="right" required :value="daoluyszhao" :rules="[{ validator:validatorDaoluyszhao, message: '请填写道路运输证号' }]" placeholder="请输入">
              <template #label>
                <span class="input-left-label-hq">道路运输证号</span>
              </template>
            </van-field>

            <ChoseTime :timeVmodel="dlysYxq" :timeName="dlysYxq" :timeLabel="dlysYxqLabel" @getYxq="getDlysYxq" :timeValue="daoluyszyxq" />
            <ChosePz :pzTitle="pzTitle" :isShowImportant="true" @getChosePz="getDlysChosePz" :resultPz="pzArray" />

            <h2 class="upload-titile input-title-hq title-extend">罐检图片（请上传含车挂号、罐容、介质、有效期页面的图片）</h2>
            <!--<span class="by-red">*</span>-->
            <div class="upload-dlysz-box">
              <van-uploader :max-size="10 * 1024 * 1024" @oversize="onOversize" v-model="guanjianbgimage"  :before-read="beforeRead" :after-read="uploadGtImage" :before-delete="deleteGtImage"></van-uploader>
            </div>

            <van-field v-model="guantitiji" name="guantitiji" input-align="right" required :value="guantitiji" type="number" :rules="[{ validator:validatorGuantitiji, message: '请填写罐体体积' }]">
              <template #extra>
                <div class="unit">立方</div>
              </template>
              <template #label>
                <span class="input-left-label-hq">罐体体积</span>
              </template>
            </van-field>

            <ChoseTime :timeVmodel="guanjianyxq" :timeName="guanjianyxq" :timeLabel="guanjianyxqLabel" @getYxq="getguanjianyxq" :timeValue="guanjianyxq" :timeRequire="false" />

            <ChosePz :pzTitle="gtPzTitle" :isShowImportant="false" @getChosePz="getGtChosePz" :resultPz="gtPzArray" />

            <van-field v-model="beizhu" autosize name="beizhu" input-align="right" type="textarea" rows="3" maxlength="50" placeholder="请输入备注" :value="beizhu">
              <template #label>
                <span class="input-left-label-hq">备注</span>
              </template>
            </van-field>
          </div>
        </van-cell-group>
      </div>

      <div style="margin: 1rem;">
        <van-button round block type="info" native-type="submit" class="addBtn" @loading="loadingBtn">
          保存
        </van-button>
      </div>

    </van-form>
  </div>

</div>
</template>

<script>
import api from "@/fetch/api"
import Nav from "../Public/navTpl.vue"
import { Toast,Dialog,ImagePreview } from 'vant';
import ChoseTime from "../Public/choseTime.vue"
import ChosePz from "../Public/chosePz.vue"
import ChoseZhouShu from "../Public/ChoseZhouShu.vue"
import Compressor from 'compressorjs';
export default {
  components: {
    Nav,
    ChoseTime,
    ChosePz,
    ChoseZhouShu
  },
  data() {
    return {
      navTitle: document.title,
      leftText: "返回",
      rightText: "首页",
      leftArrow: false,
      cheShow: false,
      xsz_zb_zm_image: [],
      xsz_zb_fm_image: [],
      xsz_fb_zm_image: [],
      xsz_fb_fm_image: [],
      xsz_zb_zm_url: "",
      xsz_zb_fm_url: "",
      xsz_fb_zm_url: "",
      xsz_fb_fm_url: "",

      zongzhiliang: 0, //总质量
      //行驶证正本反面
      cheguahao: "", //车头号
      sscd: "", //所属车队
      chejiahao: "", //车辆识别代号 行驶证正本反面

      //行驶证副本正面
      xingshizhengyxq: "", //行驶证有效期
      zhengbeizhiliang: 0, //整备质量
      xingshizhenghdzzl: 0, //行驶证核定载质量

      xszYxq: "xingshizhengyxq",
      xszYxqLabel: "行驶证有效期",
      dlysYxq: "daoluyszyxq",
      dlysYxqLabel: "道路运输证有效期",

      pzTitle: "道路运输证经营范围",

      gtPzTitle: "罐检经营范围",

      dlys_zm_image: [],
      dcl_zm_image: [],
      dcl_fm_image: [],
      dlys_zm_url: "",
      dcl_zm_url: "",
      dcl_fm_url: "",

      daoluyszhao: "", //道路运输证号
      daoluyszjyfw: "", //道路运输证经营范围
      daoluyszyxq: "", //道路运输证有效期
      beizhu: "",

      loadingBtn: false,
      pzList: [], //品种信息
      selectedData: [],
      gtSelectedData: [],
      guantitiji: 0,
      guanjianyxq: "",
      guanjianyxq_title: "guanjianyxq",
      guanjianyxqLabel: "罐检有效期",
      guanjianjyfw: "",
      guanjianbgurl: "",
      guanjianbgurlArr: [],
      guanjianbgImageArr: [],
      guanjianbgimage: [],
      pzArray: [],
      gtPzArray: [],
      gzInfo: false,
      zhoushu:"",
    };
  },

  methods: {
    beforeRead(file) {
      let quality = 0.6;
      if (file.size < 4 * 1024 * 1024) {
        quality = 0.9;
      } else if (file.size >= 4 * 1024 * 1024 && file.size < 8 * 1024 * 1024) {
        quality = 0.8;
      } else {
        quality = 0.6;
      }
      return new Promise((resolve) => {
        // compressorjs 默认开启 checkOrientation 选项
        // 会将图片修正为正确方向
        new Compressor(file, {
          quality: quality,
          success(result) {
            let newfile = new File([result], file.name, {
              type: file.type
            })
            resolve(newfile)
          },
          error(err) {
            console.log('图片压缩失败---->>>>>', err)
          }
        })

      });

    },
    onOversize(file) {
      console.log(file);
      Toast('文件大小不能超过 10Mb');
    },
    validatorChegua(val) {
      if (!val) {
        Toast.fail('请填写车挂号');
        return false;
      }
      return val;
    },
    validatorChejia(val) {
      if (!val) {
        Toast.fail('请填写车辆识别代号');
        return false;
      }
      return val;
    },
    validatorDaoluyszhao(val) {
      if (!val) {
        Toast.fail('请填写道路运输证号');
        return false;
      }
      return val;
    },
    validatorSscd(val) {
      if (!val) {
        Toast.fail('请填写所属车队');
        return false;
      }
      return val;
    },

    validatorZbzl(val) {
      if (!val) {
        Toast.fail('请填写整备质量');
        return false;
      }
      return val;
    },
    validatorZongzhiliang(val) {
      if (!val) {
        Toast.fail('请填写总质量');
        return false;
      }
      return val;
    },
    validatorXingshizhenghdzzl(val) {
      if (!val) {
        Toast.fail('请填写行驶证核定载质量');
        return false;
      }
      return val;
    },
    validatorGuantitiji(val) {
      if (!val) {
        Toast.fail('请填写罐体体积');
        return false;
      }
      return val;
    },
    submitJsyTwo(values) {
      var cheguahao = values.cheguahao;
      if(cheguahao.length < 5)
      {
        Toast.fail("请输入正确的车挂号");
        return false;
      }
      if (cheguahao.includes("挂") === false) {
        Dialog.confirm({
            message: "请确认录入的车挂号" + cheguahao + "是否正确?",
          })
          .then(() => {
            this.submitJsy(values);
            // on confirm
          })
          .catch(() => {
            // on cancel
            return false;
          });
      } else {
        this.submitJsy(values);
      }
    },
    //提交表单
    submitJsy(values) {
      var that = this;
      //var openid = that.$store.state.wx_info.openid;
      var gtSelectedData = that.$data.gtSelectedData;

      var guanjianjyfw = "";
      if (gtSelectedData.length > 0) {
        for (var j = 0; j < gtSelectedData.length; j++) {
          guanjianjyfw += gtSelectedData[j] + "|";
        }
        //去掉最后一个逗号(如果不需要去掉，就不用写)
        if (guanjianjyfw.length > 0) {
          guanjianjyfw = guanjianjyfw.substr(0, guanjianjyfw.length - 1);
        }
      }

      var xingshizhengzbfmurl = that.xsz_zb_fm_url ? that.xsz_zb_fm_url : "";
      var xingshizhengfbzmurl = that.xsz_fb_zm_url ? that.xsz_fb_zm_url : "";
      var daoluyszzbzmurl = that.dlys_zm_url ? that.dlys_zm_url : "";
      var xingshizhengzbzmurl = that.xsz_zb_zm_url ? that.xsz_zb_zm_url: "";
      if (!xingshizhengzbfmurl) {
        Toast.fail('请上传行驶证正页');
        return false;
      }
      if (!xingshizhengfbzmurl) {
        Toast.fail('请上传行驶证副页');
        return false;
      }
      if (!xingshizhengzbzmurl) {
        Toast.fail('请上传槽车整体照片（能看见车挂号、轴数）');
        return false;
      }


      if (!daoluyszzbzmurl) {
        Toast.fail('请上传道路运输证正本正面图片');
        return false;
      }


      var selectedData = that.$data.selectedData;
      if (selectedData.length == 0) {
        Toast.fail('请选择道路运输证经营范围');
        return false;
      }

      var daoluyszjyfw = "";
      for (var i = 0; i < selectedData.length; i++) {
        daoluyszjyfw += selectedData[i] + "|";
      }
      //去掉最后一个逗号(如果不需要去掉，就不用写)
      if (daoluyszjyfw.length > 0) {
        daoluyszjyfw = daoluyszjyfw.substr(0, daoluyszjyfw.length - 1);
      }

      var guanjianbgurl = "";
      var guanjianbgurlArr = that.guanjianbgurlArr;
      if (guanjianbgurlArr.length > 0) {
        for (var k = 0; k < guanjianbgurlArr.length; k++) {
          guanjianbgurl += guanjianbgurlArr[k] + ",";
        }
        //去掉最后一个逗号(如果不需要去掉，就不用写)
        if (guanjianbgurl.length > 0) {
          guanjianbgurl = guanjianbgurl.substr(0, guanjianbgurl.length - 1);
        }
      }

      var zhengbeizhiliang = values.zhengbeizhiliang ? values.zhengbeizhiliang : 0;
      if (parseFloat(zhengbeizhiliang) <= 0) {
        Toast.fail('请填写正确的整备质量');
        return false;
      }

      var guantitiji = values.guantitiji;
      if (parseFloat(guantitiji) <= 0) {
        Toast.fail('请填写正确的罐体体积');
        return false;
      }

      var zongzhiliang = values.zongzhiliang ? values.zongzhiliang : 0;
      var xingshizhenghdzzl = values.xingshizhenghdzzl ? values.xingshizhenghdzzl : 0;

      that.$data.loadingBtn = true;
      var formData = JSON.stringify({
        openid: that.$store.state.wx_info.openid,
        cheguahao: values.cheguahao,
        xingshizhengyxq: that.$data.xingshizhengyxq,
        sscd: values.sscd,
        zhengbeizhiliang: zhengbeizhiliang,
        zongzhiliang: zongzhiliang,
        chejiahao: values.chejiahao ? values.chejiahao : "",
        xingshizhenghdzzl: xingshizhenghdzzl,
        xingshizhengzbzmurl: that.$data.xsz_zb_zm_url,
        xingshizhengzbfmurl: that.$data.xsz_zb_fm_url,
        xingshizhengfbzmurl: that.$data.xsz_fb_zm_url,
        xingshizhengfbfmurl: that.$data.xsz_fb_fm_url,
        daoluyszhao: values.daoluyszhao,
        daoluyszjyfw: daoluyszjyfw,
        daoluyszyxq: that.$data.daoluyszyxq,
        daoluyszzbzmurl: that.$data.dlys_zm_url,
        daoluyszdlzmurl: that.$data.dcl_zm_url,
        daoluyszdlfmurl: that.$data.dcl_fm_url,
        guanjianjyfw: guanjianjyfw,
        guantitiji: guantitiji,
        guanjianyxq: that.$data.guanjianyxq,
        guanjianbgurl: guanjianbgurl,
        beizhu: values.beizhu,
        zhoushu:that.zhoushu,
      });

      if (guanjianjyfw) {
        api.isgeneralgood(guanjianjyfw).then(function(res) {
          var resData = JSON.parse(res);
          if (resData.respCode == "0") {
            if (resData.data == 'N') {
              if (guanjianbgurlArr.length == 0) {
                Toast.fail('请上传罐检图片');
                return false;
              }

              if (!that.$data.guanjianyxq) {
                Toast.fail('请选择罐检有效期');
                return false;
              }

              if (gtSelectedData.length == 0) {
                Toast.fail('请选择罐检经营范围');
                return false;
              }
            }

            that.uploadFormData(formData);

          } else {
            Dialog.alert({
              message: resData.message,
            }).then(() => {
              // on confirm
            });
          }
        });
      } else {
        that.uploadFormData(formData);
      }

    },
    uploadFormData(formData) {
      var that = this;
      api.beianChegua(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          Dialog.alert({
            message: '信息保存成功',
          }).then(() => {
            that.$router.push({
              name: 'vehicle',
              params: {
                type: 1
              }
            })
          });
        } else {
          Dialog.alert({
            message: resData.message,
          }).then(() => {
            // on confirm
          });
        }
      }).catch(function(err) {
        console.log(err);
        that.$data.loadingBtn = false;
        Toast.fail('连接失败，请刷新页面');

      });
    },
    getZhouShu(zhoushu)
    {
      this.zhoushu = zhoushu;
    },
    getXszYxq(xszYxq) {
      this.$data.xingshizhengyxq = xszYxq;
    },
    getDlysYxq(xszYxq) {
      this.$data.daoluyszyxq = xszYxq
    },
    getDlysChosePz(selectedData) {
      this.$data.selectedData = selectedData;
      this.pzArray = selectedData;
    },
    getGtChosePz(selectedData) {
      this.$data.gtSelectedData = selectedData;
      this.gtPzArray = selectedData;

    },
    getguanjianyxq(xszYxq) {
      this.$data.guanjianyxq = xszYxq
    },
    mergeinfo(detail) {
      var that = this;
      const weburl = that.GLOBAL.weburl;
      that.cheguahao = detail.cheguahao ? detail.cheguahao : that.cheguahao;
      that.xingshizhengyxq = detail.xingshizhengyxq ? detail.xingshizhengyxq : that.xingshizhengyxq;
      that.sscd = detail.sscd ? detail.sscd : that.sscd;
      that.zhengbeizhiliang = detail.zhengbeizhiliang ? detail.zhengbeizhiliang : that.zhengbeizhiliang;
      that.zongzhiliang = detail.zongzhiliang ? detail.zongzhiliang : that.zongzhiliang;
      that.chejiahao = detail.chejiahao ? detail.chejiahao : that.chejiahao;
      that.xingshizhenghdzzl = detail.xingshizhenghdzzl ? detail.xingshizhenghdzzl : that.xingshizhenghdzzl;
      that.daoluyszhao = detail.daoluyszhao ? detail.daoluyszhao : that.daoluyszhao;
      that.beizhu = detail.beizhu ? detail.beizhu : that.beizhu;
      that.daoluyszyxq = detail.daoluyszyxq ? detail.daoluyszyxq : that.daoluyszyxq;
      that.guantitiji = detail.guantitiji ? detail.guantitiji : that.guantitiji;
      that.guanjianyxq = detail.guanjianyxq ? detail.guanjianyxq : that.guanjianyxq;
      that.guanjianjyfw = detail.guanjianjyfw ? detail.guanjianjyfw : that.guanjianjyfw;
      that.zhoushu = detail.zhoushu;

      var daoluyszjyfw = that.daoluyszjyfw = detail.daoluyszjyfw;
      var pzArrayOld = daoluyszjyfw.split('|');

      let pzArrayNew = [];
      //var pzList = that.pzList;
      for (var i = 0; i < pzArrayOld.length; i++) {
        pzArrayNew.push(pzArrayOld[i]);
      }
      that.selectedData = that.pzArray = pzArrayNew;

      var guanjianjyfw = that.guanjianjyfw;
      var gtPzArrayOld = guanjianjyfw.split('|');

      let gtPzArrayNew = [];
      for (var j = 0; j < gtPzArrayOld.length; j++) {
        gtPzArrayNew.push(gtPzArrayOld[j]);
      }
      that.gtPzArray = that.gtSelectedData = gtPzArrayNew;

      that.xsz_zb_zm_url = detail.xingshizhengzbzmurl ? detail.xingshizhengzbzmurl : that.xsz_zb_zm_url;
      that.xsz_zb_fm_url = detail.xingshizhengzbfmurl ? detail.xingshizhengzbfmurl : that.xsz_zb_fm_url;
      that.xsz_fb_zm_url = detail.xingshizhengfbzmurl ? detail.xingshizhengfbzmurl : that.xsz_fb_zm_url;
      that.xsz_fb_fm_url = detail.xingshizhengfbfmurl ? detail.xingshizhengfbfmurl : that.xsz_fb_fm_url;
      that.dlys_zm_url = detail.daoluyszzbzmurl ? detail.daoluyszzbzmurl : that.dlys_zm_url;
      that.dcl_zm_url = detail.daoluyszdlzmurl ? detail.daoluyszdlzmurl : that.dcl_zm_url;
      that.dcl_fm_url = detail.daoluyszdlfmurl ? detail.daoluyszdlfmurl : that.dcl_fm_url;


      that.xsz_zb_zm_image = detail.xingshizhengzbzmurl ? [{
        url: weburl + '/' + detail.xingshizhengzbzmurl
      }] : that.xsz_zb_zm_image;
      that.xsz_zb_fm_image = detail.xingshizhengzbfmurl ? [{
        url: weburl + '/' + detail.xingshizhengzbfmurl
      }] : that.xsz_zb_fm_image;
      that.xsz_fb_zm_image = detail.xingshizhengfbzmurl ? [{
        url: weburl + '/' + detail.xingshizhengfbzmurl
      }] : that.xsz_fb_zm_image;
      that.xsz_fb_fm_image = detail.xingshizhengfbfmurl ? [{
        url: weburl + '/' + detail.xingshizhengfbfmurl
      }] : that.xsz_fb_fm_image;
      that.dlys_zm_image = detail.daoluyszzbzmurl ? [{
        url: weburl + '/' + detail.daoluyszzbzmurl
      }] : that.dlys_zm_image;
      that.dcl_zm_image = detail.daoluyszdlzmurl ? [{
        url: weburl + '/' + detail.daoluyszdlzmurl
      }] : [];
      that.$data.dcl_fm_image = detail.daoluyszdlfmurl ? [{
        url: weburl + '/' + detail.daoluyszdlfmurl
      }] : that.$data.dcl_fm_image;

      var guanjianbgurl = detail.guanjianbgurl;
      var guanjianbgImageArr = that.guanjianbgImageArr;
      var guanjianbgurlArr = that.guanjianbgurlArr;
      if (guanjianbgurl) {
        var imageDataArr = guanjianbgurl.split(',');
        for (var k = 0; k < imageDataArr.length; k++) {
          if (guanjianbgImageArr.length > 0) {
            guanjianbgImageArr.push({
              'url': weburl + '/' + imageDataArr[k]
            });
            guanjianbgurlArr.push(imageDataArr[k]);
          } else {
            guanjianbgImageArr = imageDataArr[k] ? [{
              url: weburl + '/' + imageDataArr[k]
            }] : [];
            guanjianbgurlArr = imageDataArr[k] ? [imageDataArr[k]] : [];
          }
        }

        that.guanjianbgimage = that.guanjianbgImageArr = guanjianbgImageArr;
        that.guanjianbgurlArr = guanjianbgurlArr;
      }
    },
    //上传行驶证正本正面
    uploadXszZbZm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const type = 'xsz_zb_zm'
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      api.uploadCheguaXsz(type, formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.$data.xsz_zb_zm_url = imageData.xingshizhengzbzmurl ? imageData.xingshizhengzbzmurl : "";
          that.$data.xsz_zb_zm_image = imageData.xingshizhengzbzmurl ? [{
            url: weburl + '/' + imageData.xingshizhengzbzmurl
          }] : [];
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);

      });
    },
    //上传行驶证正本反面 正页
    uploadXszZbFm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const type = 'xsz_zb_fm'
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      api.uploadCheguaXsz(type, formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.$data.xsz_zb_fm_url = imageData.xingshizhengzbfmurl ? imageData.xingshizhengzbfmurl : "";
          that.$data.xsz_zb_fm_image = imageData.xingshizhengzbfmurl ? [{
            url: weburl + '/' + imageData.xingshizhengzbfmurl
          }] : [];

          if (imageData.bpmStatus === "3") {
            var detail = imageData;
            that.mergeinfo(detail);
          } else {
            that.$data.xsz_zb_fm_url = imageData.xingshizhengzbfmurl ? imageData.xingshizhengzbfmurl : "";
            that.$data.cheguahao = imageData.cheguahao ? imageData.cheguahao : that.$data.cheguahao; //车头号
            that.$data.sscd = imageData.sscd ? imageData.sscd : that.$data.sscd; //所属车队
            that.$data.chejiahao = imageData.chejiahao ? imageData.chejiahao : that.$data.chejiahao; //车辆识别代号
          }

        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);

      });
    },
    //上传行驶证副本正面 副页
    uploadXszFbZm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const type = 'xsz_fb_zm'
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');

      api.uploadCheguaXsz(type, formData).then(function(res) {

        var resData = JSON.parse(res);

        if (resData.respCode == "0") {

          var imageData = resData.data;
          that.$data.xsz_fb_zm_url = imageData.xingshizhengfbzmurl ? imageData.xingshizhengfbzmurl : "";
          that.$data.xsz_fb_zm_image = imageData.xingshizhengfbzmurl ? [{
            url: weburl + '/' + imageData.xingshizhengfbzmurl
          }] : [];

          if (imageData.bpmStatus === "3") {
            var detail = imageData;
            that.mergeinfo(detail);
          } else {
            that.$data.xingshizhengyxq = imageData.xingshizhengyxq ? imageData.xingshizhengyxq : that.$data.xingshizhengyxq; //行驶证有效期
            that.$data.zhengbeizhiliang = imageData.zhengbeizhiliang ? imageData.zhengbeizhiliang : that.$data.zhengbeizhiliang; //整备质量
            that.$data.zongzhiliang = imageData.zongzhiliang ? imageData.zongzhiliang : that.$data.zongzhiliang; //总质量
            that.$data.xingshizhenghdzzl = imageData.xingshizhenghdzzl ? imageData.xingshizhenghdzzl : that.$data.xingshizhenghdzzl; //行驶证核定载质量
          }
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    //上传行驶证副本反面
    uploadXszFbFm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const type = 'xsz_fb_fm'
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      api.uploadCheguaXsz(type, formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.$data.xsz_fb_fm_url = imageData.xingshizhengfbfmurl ? imageData.xingshizhengfbfmurl : "";
          that.$data.xsz_fb_fm_image = imageData.xingshizhengfbfmurl ? [{
            url: weburl + '/' + imageData.xingshizhengfbfmurl
          }] : [];
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }

      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    //道路运输证正本正面图片
    uploadDlysZm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      api.uploadDlys(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.$data.dlys_zm_url = imageData.daoluyszzbzmurl ? imageData.daoluyszzbzmurl : "";
          that.$data.dlys_zm_image = imageData.daoluyszzbzmurl ? [{
            url: weburl + '/' + imageData.daoluyszzbzmurl
          }] : [];
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });

    },
    uploadDclZm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      const type = 'dcl_zm';
      api.uploadDcl(type, formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.$data.dcl_zm_url = imageData.daoluyszdlzmurl ? imageData.daoluyszdlzmurl : "";
          that.$data.dcl_zm_image = imageData.daoluyszdlzmurl ? [{
            url: weburl + '/' + imageData.daoluyszdlzmurl
          }] : [];
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    uploadDclFm(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const weburl = that.GLOBAL.weburl;
      let formData = new FormData();
      formData.append("uploadpics", file.file);
      formData.append("ctid", '');
      const type = 'dcl_fm';
      api.uploadDcl(type, formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data;
          that.$data.dcl_fm_url = imageData.daoluyszdlfmurl ? imageData.daoluyszdlfmurl : "";
          that.$data.dcl_fm_image = imageData.daoluyszdlfmurl ? [{
            url: weburl + '/' + imageData.daoluyszdlfmurl
          }] : [];
        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    uploadGtImage(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      var that = this;
      const weburl = that.GLOBAL.weburl;

      let formData = new FormData();
      if (Array.isArray(file)) {
        file.forEach((item) => {
          formData.append("uploadpics", item.file);
        })
      } else {
        formData.append("uploadpics", file.file);
      }

      formData.append("ctid", '');
      api.uploadGtImage(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          var imageData = resData.data.guanjianbgurl;
          var guanjianbgImageArr = that.guanjianbgImageArr;
          var guanjianbgurlArr = that.guanjianbgurlArr;

          var imageDataArr = imageData.split(',');

          for (var i = 0; i < imageDataArr.length; i++) {
            if (guanjianbgImageArr.length > 0) {
              guanjianbgImageArr.push({
                'url': weburl + '/' + imageDataArr[i]
              });
              guanjianbgurlArr.push(imageDataArr[i]);
            } else {
              guanjianbgImageArr = imageDataArr[i] ? [{
                url: weburl + '/' + imageDataArr[i]
              }] : [];
              guanjianbgurlArr = imageDataArr[i] ? [imageDataArr[i]] : [];
            }
          }

          that.guanjianbgimage = that.guanjianbgImageArr = guanjianbgImageArr;
          that.guanjianbgurlArr = guanjianbgurlArr;

        } else {
          setTimeout(() => {
            file.status = 'failed';
            file.message = '上传失败';
          }, 1000);
          Toast.fail(resData.message);
        }
      }).catch(function(err) {
        console.log(err);
        Toast.fail('上传图片失败，请重新再试');
        setTimeout(() => {
          file.status = 'failed';
          file.message = '上传失败';
        }, 1000);
      });
    },
    deleteXszZbFm() {
      this.$data.xsz_zb_fm_url = "";
      this.$data.xsz_zb_fm_image = [];
    },
    deleteXszFbZm() {
      this.$data.xsz_fb_zm_url = "";
      this.$data.xsz_fb_zm_image = [];
    },
    deleteXszFbFm() {
      this.$data.xsz_fb_fm_url = "";
      this.$data.xsz_fb_fm_image = [];
    },
    deleteXszZbZm() {
      this.$data.xsz_zb_zm_url = "";
      this.$data.xsz_zb_zm_image = [];
    },
    deleteDlysZm() {
      this.$data.dlys_zm_url = "";
      this.$data.dlys_zm_image = [];
    },
    deleteDclZm() {
      this.$data.dcl_zm_url = "";
      this.$data.dcl_zm_image = [];
    },
    deleteDclFm() {
      this.$data.dcl_fm_url = "";
      this.$data.dcl_fm_image = [];
    },
    deleteGtImage(file) {
      var that = this;
      const weburl = that.GLOBAL.weburl;
      var guanjianbgImageArr = that.guanjianbgImageArr;
      var guanjianbgNewImageArr = [];
      var guanjianbgNewUrlArr = [];
      for (var i = 0; i < guanjianbgImageArr.length; i++) {
        if (guanjianbgImageArr[i].url != file.url) {
          guanjianbgNewImageArr.push(guanjianbgImageArr[i]);
          var path = guanjianbgImageArr[i].url.replace(weburl, '');
          guanjianbgNewUrlArr.push(path);
        }
      }
      that.guanjianbgimage = that.guanjianbgImageArr = guanjianbgNewImageArr;
      that.guanjianbgurlArr = guanjianbgNewUrlArr;
    },
    
    showImageDemo(type) {
      let images = [];
      switch (type) {
        case 'zbzm':
          images = [require('@/assets/images/cgsl.png')];
          break;
        case 'zbfm':
          images = [require('@/assets/images/zbfm.png')];
          break;
        case 'fbzm':
          images = [require('@/assets/images/fbzm.png')];
          break;
        case 'fbfm':
          images = [require('@/assets/images/fbfm.png')];
          break;
        case 'dlyszm':
          images = [require('@/assets/images/cgdlyszm.png')];
          break;
        case 'dlczm':
          images = [require('@/assets/images/cgdlczm.jpg')];
          break;
        case 'dlcfm':
          images = [require('@/assets/images/dlcfm.jpg')];
          break;
      }

      ImagePreview({
        images: images,
        closeable: true,
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.content {
    margin-top: 4.75rem;
}

.itemBox {
    margin-top: 1rem;
}

.upload-box {
    //border-top: 1px solid #ececec;
    background: #fff;
    margin-top: 0.625rem;
    .upload-titile {
        padding: 0.675rem 1rem;
        .image-show {
            margin-left: 0.5rem;
            color: #2440b3;
        }
    }
    .title-extend {
        line-height: 1.5;
    }
    .upload-xsz-box {
        margin-left: 1rem;
    }
    .upload-dlysz-box {
        margin-left: 1rem;
    }

}

.pz-box {
    .van-checkbox-group {
        margin-left: 1rem;
    }
}

.unit {
    padding-left: 0.2rem;
    color: #969799;
}
</style>
